export const transitions = {
  main: "all .3s",
};
